import PageContent from 'layouts/PageContent';
import React from 'react';
import { useTranslation } from 'react-i18next';
import NailPriceVisualizer from './NailPriceVisualizer';

const NailPriceVisualizerScreen = (props) => {
  const {t, i18n} = useTranslation(['operations', 'common']); // Translation

  return (
    <>
      <PageContent title={t('operations:NailPriceVisualizer')}>
        <NailPriceVisualizer />
      </PageContent>
    </>
  )
}

export default NailPriceVisualizerScreen;